import { Component } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { FooterComponent } from '../footer/footer.component';
import { RegistrationHeaderComponent } from '../registration-header/registration-header.component';

@Component({
  selector: 'app-registration-layout',
  imports: [
    RouterOutlet,
    RegistrationHeaderComponent,
    FooterComponent,
  ],
  templateUrl: './registration-layout.component.html',
  styleUrl: './registration-layout.component.scss'
})
export class RegistrationLayoutComponent {
  logoSrc = '';
  title = '';

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.data.subscribe(data => {
      console.log('Resolved data:', data);
      const event = data['event'];
      if (event) {
        // this.logoSrc = `${environment.api_url}/assets/logos/${event.logoFileName}`;
        this.logoSrc = `${environment.public_url}/assets/logos/${event.logoFileName}`;
        this.title = event.name;
      }
    });
  }
}
